import { useRef, useState } from "react";
import { usePageTitle } from "@/i18n/LanguageContext";
import { pages } from "@/site/content/pages";
import { useContent, useReveal, SlotInspector } from "@/site/ui/helpers";
import { HeroCarousel } from "@/site/home/HeroCarousel";
import { Statement } from "@/site/home/Statement";
import { PlatformModel } from "@/site/home/PlatformModel";
import { Flow } from "@/site/home/Flow";
import { RoleViews } from "@/site/home/RoleViews";
import { StationDemo } from "@/site/home/StationDemo";
import { Problems } from "@/site/home/Problems";
import { DeployPath, ExploreRail, SignOff } from "@/site/home/PathVisionExplore";
import { FilmDialog } from "@/site/home/FilmDialog";
import { DigitalTwin } from "@/site/twin/DigitalTwin";

/*
  HOMEPAGE — section order. To hide a section, delete its line; to reorder, move lines.
  Story: what KSS does (hero, statement) → how it works (platform layers, 9-step flow)
         → who uses it → one bundle at a station → digital twin challenge
         → problems it helps with → start with one line → explore → contact.
  Text: src/site/content/home.js   Media: src/site/media.js   Styles: src/site/site.css
*/
export default function Home() {
  usePageTitle("home");
  const root = useRef(null);
  const [film, setFilm] = useState(false);
  const common = useContent(pages).common;
  useReveal(root);

  return (
    <div className="kss-v2 k-page" ref={root} data-testid="home-page">
      <HeroCarousel onFilm={() => setFilm(true)} />
      <Statement />
      <PlatformModel />
      <Flow />
      <RoleViews />
      <StationDemo />
      <DigitalTwin />
      <Problems />
      <DeployPath />
      <ExploreRail onFilm={() => setFilm(true)} />
      <SignOff />

      <FilmDialog open={film} onClose={() => setFilm(false)} title={common.filmTitle} closeLabel={common.filmClose} />
      <SlotInspector rootRef={root} />
    </div>
  );
}
